import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  name: string;
  data: { label: string; value: string }[];
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  name: "",
  data: [],
};

const getListEmployeeSlice = createSlice({
  name: "getListEmployee",
  initialState,
  reducers: {
    getListEmployeeStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getListEmployeeSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getListEmployeeFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetListEmployee: () => {
      return { ...initialState };
    },
    resetDataEmployee: (state) => {
      state.data = [];
    },
    onChangeName: (state, action) => {
      state.name = action.payload;
    },
  },
});

export const {
  getListEmployeeStart,
  getListEmployeeSuccess,
  getListEmployeeFailed,
  resetListEmployee,
  onChangeName,
  resetDataEmployee,
} = getListEmployeeSlice.actions;

export default getListEmployeeSlice.reducer;
